<template>
    <div class="widget widget-newsletter d-flex align-items-center col-md-12" style="margin-top:2rem;width:100%;">
        <div class="row" style="width:100vw">

            <title-newsletter class="col-xl-6 col-lg-7 col-md-6 col-12">
                <h3 style="line-height: 20px;"><i class="icon-envolope"></i>Receba novidades</h3>
                <p>Fique por dentro de novidades e ofertas assinando nossa Newsletter</p>
            </title-newsletter>

            <div class="col-xl-6 col-lg-5 col-md-6 col-12 form-and-social-media">
                <div class="col-md-8 form-newsletter"> 
                    <form 
                        @submit.prevent="submit"
                        action="post" style="width: 100%;"
                    >   
                        <LoadingApp
                            :isLoading.sync="isLoading" 
                            :is_full_page="true"
                        /> 
                        <div class="input-group">
                            <input 
                                type="email" 
                                v-model="email" 
                                class="form-control form-control-sm" 
                                :style="'background-color:#ffffff; height: '+layout.btn.height+';font-family:'+$root.$children[0].theme.font_family+'; padding: 1.2rem 1.5rem; border-radius:'+layout.input.border_radius+';'" 
                                placeholder="Email" 
                                required
                            >
                            <div class="input-group-append">
                                <c-button 
                                    :backgroundColor="layout.btn.background_color"
                                    :backgroundColorHover="layout.btn.background_color_hover"
                                    :backgroundColorFocus="layout.btn.background_color_hover"
                                    :color="layout.btn.color"
                                    :colorHover="layout.btn.color_hover"
                                    :colorFocus="layout.btn.color_hover"
                                    :borderColor="layout.btn.border_color"
                                    :borderColorHover="layout.btn.border_color_hover"
                                    :borderColorFocus="layout.btn.border_color_hover"
                                    :textTransform="layout.btn.text_transform"
                                    :fontSize="layout.btn.font_size"
                                    :borderRadius="layout.btn.border_radius"
                                    :height="layout.btn.height"
                                    :padding="layout.btn.padding"
                                    letterSpacing="0.2px"
                                    margin="unset"
                                    type="submit" 
                                    :style="`font-weight: ${layout.btn.font_weight}; font-family: ${layout.btn.font_family};`"
                                >
                                    <!-- @click.stop="modalProduct()" -->
                                    Assinar
                                </c-button>
                            </div>
                        </div>
                    </form>
                </div>
                <social-media-newsletter class="col-md-4">
                    <div class="social-media-icon">
                        <slot name="social-newsletter"></slot>
                    </div>
                </social-media-newsletter>
            </div>
        </div>
    </div>
</template>

<script>
import {
    CTitleNewsletter,
    CSocialMediaNewsletter
} from './Styles/Footer/styled'

import {mapActions, mapState} from 'vuex'
import LoadingApp from './LoadingApp'
import {CButton} from './Styles/Button/styled'

export default {
    name: 'Newsletter',
    components: {
        'title-newsletter': CTitleNewsletter,
        'social-media-newsletter': CSocialMediaNewsletter,
        LoadingApp,
        'c-button': CButton
    },
    data() {
        return {
            isLoading: false,
            email: '',
            layout: {
                btn: {
                    background_color: this.$root.$children[0].theme?.footer?.newsletter?.btn?.background_color ?? '#3c3232',
                    background_color_hover: this.$root.$children[0].theme?.footer?.newsletter?.btn?.background_color_hover ?? '#90969a',
                    color: this.$root.$children[0].theme?.footer?.newsletter?.btn?.color ?? '#fff',
                    color_hover: this.$root.$children[0].theme?.footer?.newsletter?.btn?.color_hover ?? '#fff',
                    border_color: this.$root.$children[0].theme?.footer?.newsletter?.btn?.border_color ?? 'transparent',
                    border_color_hover: this.$root.$children[0].theme?.footer?.newsletter?.btn?.border_color_hover ?? 'transparent',
                    text_transform: this.$root.$children[0].theme?.footer?.newsletter?.btn?.text_transform ?? this.$root.$children[0].theme.footer.text_transform_title,
                    font_size: this.$root.$children[0].theme?.footer?.newsletter?.btn?.font_size ?? this.$root.$children[0].theme.font_size_button,
                    font_weight: this.$root.$children[0].theme?.footer?.newsletter?.btn?.font_weight ?? '400',
                    font_family: this.$root.$children[0].theme?.footer?.newsletter?.btn?.font_family ?? this.$root.$children[0].theme.footer.font_family_title,
                    border_radius: this.$root.$children[0].theme?.footer?.newsletter?.btn?.border_radius ?? '0px',
                    height: this.$root.$children[0].theme?.footer?.newsletter?.btn?.height ?? '3.8rem',
                    padding: this.$root.$children[0].theme?.footer?.newsletter?.btn?.padding ?? '0 1rem'
                },
                input: {
                    border_radius: this.$root.$children[0].theme?.footer?.newsletter?.input?.border_radius ?? '0px'
                }
            }
        }
    },
    methods: {
        ...mapActions("newsletter", [
            "ActionSaveSubscription"
        ]),
        setValidator(validator) {
            let errors = ''
            for (var [key, value] of Object.entries(validator)) {
                errors += '* '+value+'\n'
            }
            alert(errors)
        },
        async submit()
        {   
            this.isLoading = true
            try {
                let data = {
                    email: this.email,
                    location: this.location,
                    street_name: this.street_name,
                    street_number: this.street_number,
                    neighborhood: this.neighborhood,
                    postal_code: this.postal_code,
                    city: this.city,
                    uf: this.uf,
                    country: this.country,
                    latitude: this.latitude,
                    longitude: this.longitude
                }
                await this.ActionSaveSubscription(data)
                this.isLoading = false
                Object.assign(this.$data, this.$options.data.apply(this))
                alert('Assinatura realizada com sucesso')
            } catch(error) {
                this.isLoading = false
                if(error.validator) {
                    this.setValidator(error.validator)
                    return
                }
                if(error.msg) {
                    return alert(error.msg)
                }
                alert(error)
            }
        }

    },
    computed: {
        ...mapState("location", [
            "location",
            "street_name", 
            "street_number",
            "neighborhood",
            "postal_code", 
            "city",
            "uf",
            "country",
            "latitude",
            "longitude"
        ])
    }
}
</script>